import { render, staticRenderFns } from "./add-twilio-number.vue?vue&type=template&id=2bc14bc4&scoped=true"
import script from "./add-twilio-number.vue?vue&type=script&lang=js"
export * from "./add-twilio-number.vue?vue&type=script&lang=js"
import style0 from "./add-twilio-number.vue?vue&type=style&index=0&id=2bc14bc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc14bc4",
  null
  
)

export default component.exports